import { template } from "lodash";

/* eslint-disable max-len */
export const currencyValues = [
    { id: 1, name: 'GBP' },
    { id: 2, name: 'USD' },
    { id: 3, name: 'EUR' },
    { id: 4, name: 'HKD' },
    { id: 5, name: 'JPY' },
    { id: 6, name: 'CHF' },
    { id: 7, name: 'SGD' },
    { id: 8, name: 'AUD' },
    { id: 9, name: 'CAD' },
    { id: 10, name: 'INR' },
]
export  const currencySymbolMapping = {
    'GBP': '£',
    'USD': '$',
    'EUR': '€',
    'HKD': 'HK$',
    'JPY': '¥',
    'CHF': 'CHF',
    'SGD': 'S$',
    'AUD': 'A$',
    'CAD': 'C$',
    'INR': '₹',
};

export const timeZoneMap = {
    'UTC - Coordinated Universal Time': 'Etc/UTC',
    'GMT - Greenwich Mean Time': 'Etc/GMT',
    'BST - British Summer Time': 'Europe/London',
    'CET - Central European Time': 'Europe/Paris',
    'IST - India Standard Time': 'Asia/Kolkata',
    'CST - China Standard Time': 'Asia/Shanghai',
    'JST - Japan Standard Time': 'Asia/Tokyo',
    'AEST - Australian Eastern Standard Time': 'Australia/Sydney',
    'NZST - New Zealand Standard Time': 'Pacific/Auckland',
    'PST - Pacific Standard Time(US)': 'America/Los_Angeles',
    'MST - Mountain Standard Time (US)': 'America/Denver',
    'MDT - Mountain Daylight Time (US)': 'America/Denver',
    'CST - Central Standard Time (US)': 'America/Chicago',
    'EST - Eastern Standard Time (US)': 'America/New_York'
};

export const timezoneValues = [
    { id: 1, name: 'UTC - Coordinated Universal Time' },
    { id: 2, name: 'GMT - Greenwich Mean Time' },
    { id: 3, name: 'BST - British Summer Time' },
    { id: 4, name: 'CET - Central European Time' },
    { id: 5, name: 'IST - India Standard Time' },
    { id: 6, name: 'CST - China Standard Time' },
    { id: 7, name: 'JST - Japan Standard Time' },
    { id: 8, name: 'AEST - Australian Eastern Standard Time' },
    { id: 9, name: 'NZST - New Zealand Standard Time' },
    { id: 10, name: 'PST - Pacific Standard Time(US)' },
    { id: 11, name: 'MST - Mountain Standard Time (US)' },
    { id: 12, name: 'MDT - Mountain Daylight Time (US)' },
    { id: 13, name: 'CST - Central Standard Time (US)' },
    { id: 14, name: 'EST - Eastern Standard Time (US)' },
]

export const timeDifference = {
    'UTC - Coordinated Universal Time' : '' ,
    'GMT - Greenwich Mean Time' : '' ,
    'BST - British Summer Time' : '(UTC+1)' ,
    'CET - Central European Time' : '(UTC+1)' ,
    'IST - India Standard Time' : '(UTC+5:30)' ,
    'CST - China Standard Time' : '(UTC+8)' ,
    'JST - Japan Standard Time' : '(UTC+9)' ,
    'AEST - Australian Eastern Standard Time' : '(UTC+11)' ,
    'NZST - New Zealand Standard Time' : '(UTC+13)' ,
    'PST - Pacific Standard Time(US)' : '(UTC-8)' ,
    'MST - Mountain Standard Time (US)' : '(UTC-7)' ,
    'MDT - Mountain Daylight Time (US)' : '(UTC-6)' ,
    'CST - Central Standard Time (US)' : '(UTC-6)' ,
    'EST - Eastern Standard Time (US)' : '(UTC-5)' 
}

export const extenstionType = [
    { id: 1, name: 'All Lots' },
    { id: 2, name: 'Cascade' },
    { id: 3, name: 'Individual Lots' }
]
export const registrationType = [
    { id: 1, name: 'Email only' },
    { id: 2, name: 'Credit (bank) card validation' },
    { id: 3, name: 'Manual approval' }
]
export const buyerFees = [
    { id: 1, name: 'No additional fees (default)'},
    { id: 2, name: 'Add percentage' },
    { id: 3, name: 'Add fixed fee' }
]
export const FontList = [
    { id: 1, name: 'Arimo'},
    { id: 2, name: 'Comic Neue' },
    { id: 3, name: 'Courier Prime' },
    { id: 4, name: 'Gothic A1' },
    { id: 5, name: 'Lato' },
    { id: 6, name: 'Montserrat' },
    { id: 7, name: 'Open Sans' },
    { id: 8, name: 'Roboto' },
    { id: 9, name: 'Tinos' },
    { id: 10, name: 'Inter'}

]


export const emailTemplateList = [
    { 
        type: "Buyer OTP email",
        subject: "Your 6 digit code for Indy.auction",
        name: '-OTP-VALIDATION',
        default: 'buyer-default-otp-template',
        template: `
        <p style="text-align: center; font-size: 22px !important">Thank you for creating an auction account with <span style="font-size: 22px !important" contenteditable="false">*|seller_name|*</span>.</p>
        <p style="text-align: center; font-size: 18px !important"><span contenteditable="false" style="font-size: 18px !important">Please verify your email address using the 6 digit code below.</span></p>
        <div style="text-align: center; 
           font-size: 56px;
           margin: 20px auto;"
           contenteditable="false" ><span contenteditable="false">*|otp|*</span></div>
        <p style="text-align: center"><span style="font-size: 18px !important;" >This code is valid for 10 minutes.</span></p>
        <p style="text-align: center; font-size: 14px !important">If you did not register this address, please contact support@indy.auction</p>
      `
    },
   
    {
        type: "Buyer bidding paddle",
        subject: "Let the bidding begin",
        name: '-PADDLE-GENERATION',
        default: 'buyer_default_paddle_template',
        template: `
        <p>Dear <span class="noneditable" contentEditable="false" style="font-size: 14px;">*|user_first_name|*</span>,</p>
<div style="height:1px;"></div>
<p>Congratulations, <span style="font-size: 14px;">you are now registered to bid in the auction.</span></p>
<div class="se-component se-image-container __se__float-">
    <figure style="display: flex;">
        <img src="/images/imagePrototype.svg" data-align="none" alt="placeholder">
        <figcaption>
            <span class="auction-title">*|Auction_title|*</span>
            </br>Auction ends: *|auction_end_date|*
            </br>
            </br>
            <br/><br/>
            <a href="*|domainURL|*" style="margin-top: 20px">View auction</a>
            <br/><br/>
        </figcaption>
    </figure>
</div>
<div style="height:1px;"></div>
<p>Your paddle number is attached. It is unique to you and this auction.</p>
<div style="height:1px;"></div>
<div style="background-color: rgba(217, 217, 217, 1); color: rgba(161, 161, 169, 1); font-size: 60px; border-radius: 6px; margin: 12px auto; text-align: center; padding: 40px; width: fit-content;">*|paddle|*</div>
<div style="height:1px;"></div>
<p>For any questions, please contact <span style="font-size: 14px;">*|seller_email|*</span>.</p>
<br/>
<p>All our best,</p>
<p>
    <span style="font-size: 14px;">*|Seller_name|*</span>
    <div style="height:1px;"></div>
</p>

     `
    },
    {
        type: "Buyer auction registration (pending manual approval)",
        subject: "Auction registration pending approval",
        name: '-BUYER-PENDING-APPROVAL-EMAIL',
        default:'default_buyer_pending_approval_email',
    },
    {
        type: "Buyer Max Bid Confirmation",
        subject: "Max Bid: *|lot_number|*, *|lot_title|*",
        name: '-WINNING-EMAIL',
        default:'bid_notification_dev',
    },
    {
        type: "Buyer Outbid notification",
        subject: "Outbid Notification: *|lot_number|*, *|lot_title|*",
        name: '-OUTBID-EMAIL',
        default:'outbid_notification',
        template:` `
    },
    {
        type: "Buyer payment request (automated)",
        subject: "Congratulations | Payment Request",
        name: '-CONGRATULATION-EMAIL',
        default:'default_congratulations_email',
        template:''
    },
    // {
    //     type: "Buyer payment request (manually triggered)",
    //     subject: "[Congratulations | Payment Request]",
    //     name: ''
    // },
    {
        type: "Buyer payment receipt",
        subject: "Thank You | Payment Receipt",
        name: '-PAYMENT-RECEIPT',
        default:'default_payment-receipt',
        template:''
    },
    // {
    //     type: "Buyer password reset",
    //     subject: "[Reset your auction password]",
    //     name: ''
    // },
]
export const initialFAQs = [
    {
        question: 'How do I register for an auction?',
        answer:
        'Click on the "Register for the Auction" button on the auction page. Once you confirm your intent to register for the auction, you\'ll be provided with your paddle number which will also be emailed to you. Once the auction is live, you can start bidding in the auction. Please note that to validate your intent to bid for certain auctions, you might be required to enter your credit or debit card information or be requested for documents such as a photo ID or proof of funds.',
    },
    {
        question: 'What is a maximum bid?',
        answer:
        'The maximum bid (or max bid) is the highest amount you are willing to pay for an auction lot. When you set your max bid, the auction software automatically places bids on your behalf at the next available increments if other competitive bids come in to keep you as the highest bidder up to your maximum bid and never any further. If no one else bids higher, the max bidder wins the auction at the lowest possible price, which is the amount of the second-highest bid plus the minimum increment. Max bids can be advantageous for bidders who can\'t constantly monitor an auction or who want to avoid bidding wars. By placing a max bid, they can set a limit on how much they\'re willing to pay and let the system do the rest.',
    },
];
export const generateInitialTermsAndCondition = () => {
    const currentDate = new Date().toLocaleDateString()

    const termsTemplate = (brandName = '', emailAddress = '') => `
        <div>
            <p><em><strong>These terms were last updated on: ${currentDate}</strong></em></p>
            <p>These terms and conditions may have changed since you last participated in, or purchased items at an auction, please therefore ensure that you have read and understood these terms and conditions before registering to bid at, or purchase at, an auction.</p>
            <p><br></p>
            <p><em><strong>Where to find information about us, our auctions and our listed items.</strong></em></p>
            <p>
                Before you participate in an auction, you can find everything you need to know about us [${brandName}], our auctions, and the items we have listed for sale at an auction on our auction page, including details of who we are. 
                For more information you can contact us at ${emailAddress}.
                <br><br>
                We are the Auction Host for all auctions found on our auction page (as located on the page in which these terms were found). However, please note we may not always be the Seller of the Lots for sale at our auctions. 
                <br><br>
                The Seller of the Lot(s) will depend on who owns the Lot at the time that the sale is completed.
            </p>
            <p><br></p>
            <p><em><strong>Useful definitions.</strong></em></p>
            In order to make these terms and conditions clear, we have set out the following definitions, which we will use in these terms and conditions:
            <p>
                <strong>- “Auction Host”: </strong> we are the auction host, being a person or company who hosts an auction and who is listed as the host on the auction page. Please note we as the Auction Host may not always be the Seller. Any reference to the Auctioneer shall be a reference to the Auction Host and vice versa.
                <br>
                <strong>- “Bidder”: </strong> a person (whether acting as an individual or on behalf of a Trader) who is participating in an auction and is placing bids on a Lot(s). 
                <br>
                <strong>- “Buyer”: </strong> a Bidder who is successful in their bid(s) at an auction.
                <br>
                <strong>- "Indy.auction": </strong> the software/platform on which the Seller, or the Auction Host, hosts an auction. Indy.auction is not an Auction Host or Seller, nor does it have any liability or responsibility in respect of these terms.
                <br>
                <strong>- “Lot”: </strong> an item or goods listed for sale at an auction.
                <br>
                <strong>- “Seller”: </strong> the owner and seller of a Lot. Please note, a Seller is not necessarily an Auction Host.
                <br>
                <strong>- “Trader”: </strong> You are considered a trader or a business if you are a company, or if you are <i>“a person acting for purposes relating to that person's trade, business, craft or profession, whether acting personally or through another person acting in the trader's name or on the trader's behalf</i>”.
                <br>    
                <strong>- “TAC”: </strong> The owner of Indy.auction, being The Auction Collective Limited, a company registered in England and Wales (with company number: 11070414) whose registered office address is at 10 John Street, London, United Kingdom, WC1N 2EB.
                <br>
            </p>
            <p><br></p>
            <p><em><strong>When you participate in an auction, or purchase at an auction you are agreeing that:</strong></em></p>
            <nav>
                <ul>
                    <li><u><i>Section 1: By registering with us, or by bidding on a Lot(s), you agree that you will be bound by these terms and conditions.</i></u></li>
                    <li><u><i>Section 2: The Seller will be the person (or Trader) who owns the Lot at the time the sale completes.</i></u></li>
                    <li><u><i>Section 3: The Lot information will be made available to you prior to the auction.</i></u></li>
                    <li><u><i>Section 4: We may be required to undertake additional identity and proof of funds checks.</i></u></li>
                    <li><u><i>Section 5: Bidding and Auction Rules.</i></u></li>
                    <li><u><i>Section 6: We may deal with Lots and bidding as we deem appropriate.</i></u></li>
                    <li><u><i>Section 7: Payments will be due within 48 hours of the auction.</i></u></li>
                    <li><u><i>Section 8: Additional VAT, charges, interest and fees may be payable.</i></u></li>
                    <li><u><i>Section 9: Transfer of payments to Sellers will take place after a Lot is received.</i></u></li>
                    <li><u><i>Section 10: We may not always be responsible for storage and delivery.</i></u></li>
                    <li><u><i>Section 11: We're not responsible for delays outside our control.</i></u></li>
                    <li><u><i>Section 12: Returns and Refunds.</a></i></u></li>
                    <li><u><i>Section 13: We can end our contract with you.</i></u></li>
                    <li><u><i>Section 14: There are additional or different terms that apply to you if you are a business customer, or trader.</i></u></li>
                    <li><u><i>Section 15: We don't compensate you for all losses caused by us.</i></u></li>
                    <li><u><i>Section 16: You have several options for resolving disputes with us.</i></u></li>
                    <li><u><i>Section 17: Other important terms apply to our contract.</i></u></li>
                </ul>
            </nav>
            <p><br></p>
            <em><strong><em>1. By registering with us, or by bidding on a Lot(s), you agree that you will be bound by these terms and conditions.</strong></em>
            <p>
                If you sign up to participate in our auctions, we will take you through our registration process which may involve, email capture, bank card validation, KYC checks or any other registration process as we require from time to time. 
                If you do not provide the information requested from us, we will not be able to register you to participate in an auction, and you will not be able to bid.
            <br>
                This registration process will allow you to bid at an auction. By registering, and/or bidding, you are confirming that you agree to be bound by these terms and conditions.  
            <br>
                It is your responsibility to ensure that you have provided complete and accurate registration details.
            <br>
                We reserve the right to reject the registration of a Bidder, reject the final purchase of a Buyer, or block a Bidder during an auction, for any reason and at our sole discretion (including if registration and identity checks cannot be conducted or completed to our satisfaction). 
            </p>
            <p><br></p>

            <p><em><strong>2. The Seller will be the person (or Trader) who owns the Lot at the time the sale completes.</strong></em></p>
            <p>
                The Seller of a Lots will be the person (or Trader) who owns that Lot at the time the sale completes. This will usually be us, but may be a third-party Seller. If this is not us, the Seller may not always be disclosed to you. 
            <br>
                Where we are not the Seller, we are providing a service to the Seller in order to help them sell their Lot(s). We will act on behalf of the Seller, as an agent, and complete the contract between you and the Seller. 
            <br>
                The sale of the Lot to you (as a Buyer) will be between the Seller and the Buyer.
            <p><br></p>

            <p><em><strong>3. The Lot information will be made available to you prior to the auction.</strong></em></p>
            <p>
                We will provide a description, and where available pictures, of the Lots for sale at an auction but in some instances we rely on the Seller providing us with accurate information and images which we verify to the best of our ability.
            <br>
                Where applicable, all dimensions for Lots are approximate measures of the Lots themselves and, unless otherwise stated, do not include additions such as frames or plinths.
            <br>
                Images used in the promotion of Lots or auctions are for identification purposes only, Lots may therefore vary slightly from the images available, including in respect of condition, size, colour and, where applicable, packaging. Images therefore should not be relied on as precise indications of size or to convey full information as to the actual condition or appearance of the Lots.
            <br>
                All items are ‘sold as seen’, we therefore encourage all Bidders to enquire and conduct investigations into the Lots that they wish to place a bid on, to ensure they are happy to commit to buying the Lot.
            </p>
            <p><br></p>

            <p><em><strong>4. We may be required to undertake additional identity and proof of funds checks.</strong></em></p>
            <p>
                In some cases, subject to the Lot and the final sale price, extra due diligence checks (such as anti-money laundering checks) are needed after an auction or Lot has been paid for. We have the discretion to cancel the sale of an Item should these checks not be completed to our satisfaction, or should the results of such checks not meet our criteria.
            </P>
            <p><br></p>

            <p><em><strong>5. Bidding and Auction Rules.</strong></em></p>
            <p>
                All auctions will be timed auctions.
            <br>
                Bids will be placed as maximum bids and the software will automatically place bids on your behalf against other potential Bidders. Your bids are only increased if someone else bids against you. If no one else bids, you will win the auction Lot at the starting bid price.
            <br>
                Bids increase by a predetermined set of increments as displayed in the drop-down bid selector when placing your bid. In the event of conflicting bids (i.e. where someone has already set a maximum bid of the same amount) the bid placed first will take priority. All bids are final and binding.
            <br>
                Please see the ‘Auction Rules’ tab on our auction page for information and the rules around: 
                <ul>
                    <li>- How the auction will end;</li>
                    <li>- The bidding extensions; and</li>
                    <li>- Any applicable buyers’ commission.</li>
                </ul>
            <br>
                The rules and information set out on this ‘Auction Rules’ are explicitly incorporated into these terms and conditions, and you must comply with these rules.
            <br>
                Please ensure you have read and understood all rules and information concerning our auctions. 
            <br> 
                It is your responsibility to ensure that you have a good connection or ability to bid via your chosen method. You accept and acknowledge that all bidding methods are subject to technical and human error.
            <br>
                <u><b><strong>You acknowledge and accept that we will not be liable for any missed, invalid, failed lost or incomplete bids.</strong></b></u>
            <br>
                <b><strong>By participating in an auction, each Bidder represents and warrants that any bids placed by You, or on someone else’s behalf, are not the product of any collusive or other anti-competitive agreement and are otherwise compliant with all laws local to you, and where relevant or different, the laws local to us.</b></strong>
            </p>
            <p><br></p>

            <p><em><strong>6. We may deal with Lots and bidding as we deem appropriate.</strong></em></p>
            <p>
                We will have the discretion at any time to: 
                <ul>
                    <li>- Refuse or withdraw any bid or withdraw any Lot for sale if we reasonably believe that there has been a technical or human error, dispute or any unethical behaviour.</li>
                    <li>- Take all reasonable action to resolve an issue or dispute.</li>
                    <li>- All bids are final and binding, bids can only be withdrawn or cancelled at the absolute discretion of the Auction Host. There is no obligation on the Auction Host to withdraw, cancel or reject a bid.</li>
                </ul>
            <br>
                The highest Bidder when the countdown timer ends and the auction closes, will be the successful purchaser of the Lot, and therefore the Buyer of that Lot. Such acceptance of the highest Bidder will indicate the contract of sale between the Buyer and the Seller.
            <br>
                All decisions by us will be the full and final decision in respect of any Lots, sales or disputes during or in respect of an auction.
            </p>
            <p><br></p>

            <p><em><strong>7. Payments will be due within 48 hours of the auction.</strong></em></p>
            <p>
                Subject to any specific requirements stated prior to an auction in respect of particular Lots: 
                <ul>
                    <li>- The highest bid when the auction ends is the final price (the <b>“Hammer Price”</b>).</li>
                    <li>- The Hammer Price plus any additional Buyer Fees are due to be paid within 48 hours following the auction.</li>
                    <li>- Where additional fees are payable, we will confirm these prior to the auction, or they will be set out in section 8 below.</li>
                    <li>- Payments from anyone other than the Buyer are not permitted.</li>
                    <li>- In accordance with section 4 above, all Buyers making a payment over €10,000 in a single transaction, or a combined value of €10,000 over sequential associated transactions may be subject to anti-money laundering regulations and will be subjected to additional identity and source/proof of funds checks.</li>
                    <li>- Sales are conducted in a single currency and you may be responsible for all exchange rate differences that may occur at any time.</li>
                </ul>
                <br>
                Failure to pay for a Lot within 48 hours as above, may result in the cancellation of the sale. In the event a sale is cancelled, we may offer the underbidders, in respect of that Lot, an opportunity to purchase the Lot at a set price, or may place the Lot in the next available auction for resale.
            </p>
            <p><br></p>

            <p><em><strong>8. Additional VAT, charges, interest and fees may be payable.</strong></em></p>
            <p>
                Unless otherwise stated, all taxes, storage, packaging and shipping charges (including any import or export taxes) will be payable by the Buyer in addition to the Hammer Price plus any applicable Buyers fees.
            <br>
                If VAT is payable by the Buyer, this will be paid in addition to the Hammer Price. If the rate of VAT changes between your order date and the date we supply the product, we adjust the rate of VAT that you pay, unless you have already paid in full before the change in the rate of VAT takes effect.
            </p>
            <p><br></p>

            <p><em><strong>9. Transfer of payments to Sellers will take place after a Lot is received.</strong></em></p>
            <p>
                Any payment received from a Buyer will not be payable to the Seller until after the Lot is received by the Buyer. 
            <br>
                Payments will only be made to accounts in the name of the Seller, and we will not make any payments to any third party. 
            <br>
                We will not be liable for any delay in receiving, or sending, the above payments where we are not at fault for such delay, including but not limited to: 
                <ul>
                    <li>- Us not receiving the payment from the Buyer.</li>
                    <li>- The Buyer not receiving the Lots.</li>
                    <li>- Us not being able to conduct the required identity, anti-money laundering or proof/source of funds checks, or if the Buyer should fail to satisfy our requirements under such checks.</li>
                    <li>- The Seller not providing the required information (including banking information) to enable us to make payment.</li>
                </ul>
            </p>
            <p><br></p>

            <p><em><strong>10. We may not always be responsible for storage and delivery.</strong></em></p>
            <p>
                Where we hold the Lot at the time of the auction, we will be responsible for the storage and delivery of the Lot(s). 
            <br>
                Where we do not hold the Lot at the time of the auction, the Seller will be responsible for the storage and delivery of such Lot(s).
            <br>
                Neither we nor the Seller are obliged to release a Lot to the Buyer until full payment has been cleared by us. In some cases, this will mean that we hold payments under the required identity, anti-money laundering or proof/source of funds checks have been completed and approved to our satisfaction.
            <br>
                Unless otherwise stated, the cost of shipping is payable by the Buyer in addition to the Hammer Price.
            <br>
                The Buyer is responsible for all risk and insurance from the point in time that title in the Lot passes from the Seller to the Buyer.
            <br>
                If a Buyer pays for a Lot but fails to collect the Lot (or pay for shipping within 7 days of the auction), reasonable storage charges will be incurred and payable by the Buyer in addition to the Hammer Price and all other costs payable. Lots will not be released until all storage charges have been paid in full.
            <br>
                If a Lot is paid for but not collected within 30 days of the sale date, the sale of the Lot may be cancelled and the Hammer Price, less any storage costs incurred during the 30-day period, will be refunded.
            </p>
            <p><br></p>

            <p><em><strong>11. We're not responsible for delays outside our control.</strong></em></p>
            <p>
                We are not responsible for any delays due to an event that is outside our control, if we contact you as soon as possible to let you know and do what we can to reduce the delay.
            <br>
                As long as we do this, we will not compensate you for the delay, but if the delay is likely to be substantial you can contact us: to end the contract and receive a refund for any Lots you have paid for in advance, but not received, less reasonable costs we have already incurred.
            </p>
            <p><br></p>

            <p><em><strong>12. Returns and Refunds.</strong></em></p>
            <p>
                <em><strong>This section 12 is only applicable to non-traders/consumers (see section 14 below), and where the Auction is online only and as such you do not have an opportunity to attend in person.</strong></em>
                <br>
                You may return your purchases within 14 days of receipt, provided they are in their original condition, unused, unsealed (where you received the Lots in sealed packaging) and accompanied by any applicable original packaging and documentation. 
                <br>
                Certain Lots, such as perishable goods, products that cannot be returned for health or hygiene reasons, personalised or bespoke items, goods which become mixed inseparably with other items, and sealed goods that have been opened, are not eligible for return. 
                <br>
                You are responsible for return shipping costs unless the Lot is faulty, damaged, or not as described. Shipping fees, customs duties, and taxes are non-refundable unless the return is due to our error (such as delivering an incorrect Lot to you).
                <br>
                Refunds will be issued upon receipt and inspection of the returned item, typically within 14 business days, using the original payment method. 
                <br>
                If a Lot arrives damaged or faulty, you must notify us within 7 days of receipt, providing evidence where applicable, and once directed by us, return the Lot within 30 days of receipt of the Lot.
                <br>
                This returns policy is subject to local consumer protection laws, which take precedence in case of conflict.
            </p>
            <p><br></p>

            <p><em><strong>13. We can end our contract with you.</strong></em></p>
            <p>
                We can end our contract with you and claim any compensation due to us if:
                <ul>
                    <li>- you don't make any payment to us when it's due and you still don't make payment within 14 days of our reminding you that payment is due; or.</li>
                    <li>- you don't, within a reasonable time of us asking for it, provide us with information, cooperation or access that we need to provide our services and the Lot(s) to you.</li>
                </ul>
            </p>
            <p><br></p>

            <p><em><strong>14. There are additional or different terms that apply to you if you are a business customer, or trader.</strong></em></p>
            <p>
                There are different rules that apply to traders and non-traders.
                <br>
                <em><strong>Non-Traders (also known as, Consumers).</em></strong> You are considered a non-trader (and therefore a consumer) if you are “an individual acting for purposes which are wholly or mainly outside that individual's trade, business, craft or profession”.
                <br>
                Consumers do not include companies or limited liability partnerships, but may include sole-traders and partnerships (depending on whether the transaction is outside of their trade, business, craft or profession).
                <br>
                If you are a consumer, you will benefit from the relevant consumer regulations and protections, including the information and protections set out in these terms. The following information in this section 13, will not apply to you.
                <br>
                <em><strong>Traders and Businesses.</em></strong> You are considered a trader or a business if you are a company, or if you are “a person acting for purposes relating to that person's trade, business, craft or profession, whether acting personally or through another person acting in the trader's name or on the trader's behalf”. 
                <br>
                As a trader or a business, you will not benefit from the consumer regulations and protections unless they are expressly stated to apply in business-to-business contracts. 
                <br>
                All warranties, representations, conditions and all other terms of any kind whatsoever implied by statute or common law are, to the fullest extent permitted by applicable law, excluded from these terms, and are in agreement with you.
                <br>
                In addition to our rights to cancel our contract with you, as set out at section 12 above, we are also able to cancel our contract with you if: 
                <ul>
                    <li>- you commit a material breach of these terms (or any of and (if such breach is remediable) you fail to remedy that breach within a period of 7 days after being notified to do so;</li>
                    <li>- your financial position deteriorates so far as to reasonably justify the opinion that your ability to give effect to the terms of this agreement is in jeopardy; or</li>
                    <li>- you take or have taken against you (other than in relation to a solvent restructuring) any step or action towards your entering bankruptcy, administration, provisional liquidation or any composition or arrangement with your creditors, applying to court for or obtaining a moratorium under Part A1 of the Insolvency Act 1986, being wound up (whether voluntarily or by order of the court), being struck off the register of companies, having a receiver appointed to any of its assets, or your entering a procedure (in any jurisdiction) with a similar effect to an aforementioned procedure.</li>
                </ul>
            </p>
            <p><br></p>

            <p><em><strong>15. We don't compensate you for all losses caused by us.<p></em></strong>
            <p>
            <br>
            We're responsible for losses you suffer caused by us breaking this contract unless the loss is:
            <br>
            - <em><strong>Unexpected.</em></strong> It was not obvious that it would happen and nothing you said to us before we accepted your order meant we should have expected it (so, in the law, the loss was unforeseeable).
            <br>
            - <em><strong>Caused by a delaying event outside our control.</em></strong> As long as we have taken the steps set out in section 11 above.
            <br>
            - <em><strong>Avoidable.</em></strong> Something you could have avoided by taking reasonable action. For example, damage to your own digital content or device, which was caused by Lots we supplied (or use of Indy.auction) and which you could have avoided by following our advice to apply a free update or by correctly following the installation instructions or having the minimum system requirements advised by us.
            <br>
            - <em><strong>As a Trader: A business loss.</em></strong> Our liability for any loss you suffer in connection with your trade, business, craft or profession is limited. If you're a business, then, except in respect of the losses described below under losses we never limit or exclude:
            <ul>
                <li>- we shall not be liable to you, whether in contract, tort (including negligence), breach of statutory duty, or otherwise, for any loss of profit, or any indirect or consequential loss arising under or in connection with any contract between us; and</li>
                <li>- our total liability to you for all other losses arising under or in connection with any contract between us, whether in contract, tort (including negligence), breach of statutory duty, or otherwise, shall be limited to the total sums paid by you for products under these terms/this contract.</li>
            </ul>
            <em><strong>Losses we never limit or exclude</em></strong> Nothing in these terms shall limit or exclude our liability for:
            <ul>
                <li>- death or personal injury caused by our negligence, or the negligence of our employees, agents or subcontractors (as applicable);</li>
                <li>- fraud or fraudulent misrepresentation;</li>
                <li>- breach of the terms implied by section 12 of the Sale of Goods Act 1979 or section 2 of the Supply of Goods and Services Act 1982; or</li>
                <li>- defective products under the Consumer Protection Act 1987; or</li>
                <li>- any other matter in respect of which it would be unlawful for us to exclude or restrict liability.</li>
            </ul>
            <p><br></p>

            <p><em><strong>16. You have several options for resolving disputes with us.</strong></em></p>
            <p>
            <em><strong>- Contact us:</em></strong> We will do our best to resolve any problems you have with us, the Lots, or our services. You can find our contact information on our auction pages and at the top of these terms and conditions. 
            <br>
            <em><strong>- You can go to court.</em></strong> These terms are governed by English law.
            <br>
            <ul>
                <li><em><strong>- As a consumer/ non-trader:</em></strong> Wherever you live you can bring claims against us in the courts of the country you live in. We can claim against you in the courts of the country you live in.</li>
                <li><em><strong>- As a trader / business:</em></strong> If you are a business, you irrevocably agree to submit all disputes arising out of or in connection with our contract with you to the exclusive jurisdiction of the English courts.</li>
            </ul>
            </p>
            <p><br></p>

            <p><em><strong>17. Other important terms apply to our contract.</em></strong></p>
            <p>
            <br>
            - <em><strong>We can transfer our contract with you, so that a different organisation is responsible for supplying the service.</em></strong> We'll tell you in writing if this happens and we'll ensure that the transfer won't affect your rights under the contract.
            <br>
            - <em><strong>You can only transfer your contract with us to someone else if we agree to this.</em></strong>
            <br>
            - <em><strong>Nobody else has any rights under this contract.</em></strong> This contract is between you and us. Nobody else can enforce it and neither of us will need to ask anybody else to sign-off on ending or changing it.
            <br>
            - <em><strong>If a court invalidates some of this contract, the rest of it will still apply.</em></strong> If a court or other authority decides that some of these terms are unlawful, the rest will continue to apply.
            <br>
            - <em><strong>Even if we delay in enforcing this contract, we can still enforce it later.</em></strong> We might not immediately chase you for not doing something (like paying) or for doing something you're not allowed to, but that doesn’t mean we can't do it later. 
            </p>

        </div>
    `

    try {
        const userDataRaw = localStorage.getItem('userData')
        const { brand_name: brandName, email_address: emailAddress } = userDataRaw ? JSON.parse(userDataRaw) : {}
        return termsTemplate(brandName, emailAddress)
    } catch (error) {
        console.error('Error generating terms and conditions:', error)
        return termsTemplate()
    }
}